import { defineMessages } from 'react-intl';

export const messages = defineMessages<string>({
  strapsAndBracelets: {
    id: `allTheStrapsView.strapsAndBracelets`,
    defaultMessage: 'Straps And Bracelets',
  },
});
